// frontend/src/api/adminContributions.ts
import { api } from "./client";

export interface Contribution {
  _id: string;
  forum_name: string;
  primary_url: string;
  mirror_urls?: string[];
  notes?: string;
  screenshot_path?: string;

  submitted_by: string;
  status: "pending" | "approved" | "rejected";

  score_awarded?: number;
  created_at: string;
}


export async function fetchPendingContributions() {
  const res = await api.get("/admin/contributions/pending");
  return res.data as Contribution[];
}

export async function approveContribution(id: string, score: number) {
  return api.patch(`/admin/contributions/${id}/approve`, { score });
}

export async function rejectContribution(id: string, notes?: string) {
  return api.patch(`/admin/contributions/${id}/reject`, { notes });
}
